var map = {
	"./applab/skins": 2209,
	"./bounce/skins": 2611,
	"./craft/agent/skins": 2615,
	"./craft/code-connection/skins": 2616,
	"./craft/designer/skins": 2614,
	"./craft/simple/skins": 2613,
	"./flappy/skins": 2617,
	"./jigsaw/skins": 2630,
	"./maze/skins": 1867,
	"./netsim/skins": 2652,
	"./p5lab/skins": 2080,
	"./studio/skins": 2654,
	"./studio/starwars/skins": 2232,
	"./turtle/skins": 2278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4010;